import styles from '../CommonCss/OrderEngineCommon.module.css'
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import SelectUnit, {SelectUnitDataInt} from "../../../FormTemplate/SelectUnit/SelectUnit";
import WaitLoader from "../../../WaitLoader/WaitLoader";


interface UpdateOrderInt
{
    orderId:string
    id?:number
    fieldList: string[]
    valList: any[]
    mode:number
    notify:boolean
    addInfo?: string
}

interface OrderEngineStatePropsInt
{
    orderId:string
    pTextState: string
    onClose: ()=>void
    onSuccess?: ()=>void


}

interface StateListInt
{
    name: string
    state: number
}

export default function OrderEngineState({orderId,onClose,onSuccess,pTextState}:OrderEngineStatePropsInt){

    const orderStateData = useRef()
    const [ldrOrderState,rsOrderState,exOrderState] = useApiQuery("/ref/order/state","get",orderStateData);

    const [rsText, setRsText] = useState("")

    const orderUpdateData = useRef<UpdateOrderInt>()
    const [ldrOrderUpdate,rsOrderUpdate,exOrderUpdate] = useApiQuery("/sell/sim/order/update/field","post",orderUpdateData);

    const [textState, setTextState] = useState(pTextState)
    const updateSim = useRef<ErrorLineItemRef>(null)
    const [state, setState] = useState<SelectUnitDataInt>()
    const [stateList, setStateList] = useState<SelectUnitDataInt[]>([])
    const [notify, setNotify] = useState(false)

    const [addInfo, setAddInfo] = useState("")


    useEffect(()=>{
        exOrderState().then((e)=>{
            if(e?.success)
            {
                const x = e?.payload?.map((item: any)=>{
                    return {
                        name: item?.name,
                        val: item?.code
                    }
                })
//                setStateList(x?.filter((item:any)=>  [5,6,7,8,9,10,11,12,13,14,15,16,18,30,19,20].includes(item?.val)))
                setStateList(x?.filter((item:any)=>  ![1,2,3,4].includes(item?.val)))
                return
            }
            if(updateSim.current)updateSim.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        }).catch((e)=>{
            if(updateSim.current)updateSim.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        })
    },[orderStateData])


    const handleUpdate = () =>{
        if(! state)
        {
            if(updateSim.current)updateSim.current.show(`Не выбран статус`,true,3000)
            return

        }
        setRsText("")
        orderUpdateData.current = {
            orderId: orderId,
            mode:1,
            notify: notify,
            addInfo: addInfo?.length > 3 ? addInfo : undefined,

            fieldList: ["state"],
            valList:[state?.val]
        }
        exOrderUpdate().then((e)=>{
            if(e?.success)
            {
                if(e?.payload?.text) setRsText(e?.payload?.text)
                if(updateSim.current)updateSim.current.show(`Статус заказа ${orderId} обновлен`,false,0)
                if(onSuccess) onSuccess()
                return
            }
            if(updateSim.current)updateSim.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)
        }).catch((e)=>{
            if(updateSim.current)updateSim.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        })

    }


    return(
        <ModalWindow>
            <MainFormTemplate title={`Изменить статус`} maxWidth={"500px"} background={"white"}>
                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        <InputItem
                            val={textState }
                            mode={""}
                            title={"Статус"}

                        ></InputItem>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-sm-6 align-content-center"}>

                        <div className={styles.suCont}>
                            <SelectUnit  inData={stateList} capt={"Статус"} getVal={(e)=>{
                                const x =stateList.filter((item)=>item?.val === e[0])
                                if(x.length)
                                {
                                    setState(  x?.length ? x[0] :undefined)
                                    setTextState(x[0].name)
                                }
                            }}  />
                        </div>
                    </div>
                    <div className={"col-sm-6 align-content-center"}>
                        <InputItem
                            val={notify}
                            mode={"ei"}
                            onChange={(e)=>setNotify(e)}
                            title={"Оповестить"}
                            info={"Оповестить клиента"}
                            inputType={1}
                            titleShift={-2}

                        ></InputItem>
                    </div>


                </div>

                {notify &&
                    <div className={"row"}>
                        <div className={"col-sm-12 align-content-center"}>
                            <InputItem
                                val={addInfo}
                                mode={"ei"}
                                onChange={(e)=>setAddInfo(e)}
                                title={"Доп. информация"}
                                info={"Оповестить клиента"}
                                inputType={2}
                                titleShift={-6}
                                lineCount={5}

                            ></InputItem>
                        </div>
                    </div>


                }

                <div className={styles.rsText}>{rsText}</div>
                <ErrorLineItem ref={updateSim} ></ErrorLineItem>

                <div className={styles.actCont}>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                disabled={!state}
                                onClick={(e)=>{
                                    handleUpdate()
                                }}
                        >Обновить</button>
                    </div>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                onClick={(e)=>{
                                    onClose()
                                }}
                        >Закрыть</button>
                    </div>
                    <WaitLoader loading={ldrOrderUpdate || ldrOrderState} api={rsOrderState} onlyLoading={true}>

                    </WaitLoader>

                </div>

            </MainFormTemplate>
        </ModalWindow>
    )
}